import { FC, useEffect, useState } from 'react';
import styles from './index.module.less';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
import V2FormRadio from '@/common/components/Form/V2FormRadio/V2FormRadio';
import { isArray, refactorSelection } from '@lhb/func';
import { employeeListPermission } from '@/common/api/employee';
import { useSelector } from 'react-redux';
import { AssignType } from '@/common/components/business/ExpandStore/ts-config';
import { useMethods } from '@lhb/hook';
import { ResponsibleAccountType } from './index';

/**
 * 选择拓店责任人
 * @description
 * @demo
 */
const Component:FC<{
  form: any,
}> = ({ form }) => {

  /* state */
  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  const isAssignTypeLeader = [AssignType.Twice, AssignType.ThreeTimes].includes(tenantCheckData?.taskAssignType); // 是否指派主管（二次、三次指派兼容为同样处理）
  const [selection, setSelection] = useState<{
    /** 指派员工 */
    employeeOptions: any[],
   }>({ employeeOptions: [] });

  /* hooks */
  useEffect(() => {
    methods.getEmployeeOptions();
  }, []);

  /* methods */
  const methods = useMethods({

    /**
     * @description 获取可指派的团队人员
     */
    getEmployeeOptions: async () => {
      const params = isAssignTypeLeader && isArray(tenantCheckData?.taskAssignRoleIds) ? { roleIds: tenantCheckData?.taskAssignRoleIds } : {};
      const { objectList: data } = await employeeListPermission(params);
      const _employeeOptions = isArray(data) && data.length ? data.map((item) => ({
        ...item,
        name: `${item.name} ${item.mobile}`
      })) : [];

      setSelection(val => ({ ...val, employeeOptions: _employeeOptions }));
      if (isAssignTypeLeader && _employeeOptions.length === 1) { // 指派主管且只有一个时默认指定
        form.setFieldValue('radio', ResponsibleAccountType.ASSIGN_LEADER);
        form.setFieldValue('managerId', _employeeOptions[0].id);
      }
    },

  });

  return (<>
    <V2FormRadio
      name='radio'
      className={styles.radioList}
      options={[
        { label: '指派给自己', value: ResponsibleAccountType.ASSIGN_SELF },
        {
          label: isAssignTypeLeader ? (
            <div className={styles.radioSelect}>
              <span>指派给开发主管</span>
              <V2FormSelect
                className={styles.assignAccountIds}
                placeholder='请选择开发主管'
                name='managerId'
                options={refactorSelection(selection.employeeOptions)}
                config={{
                  showSearch: true,
                  onClick: e => {
                    e.preventDefault();
                    e.stopPropagation;
                  }, // 解决下拉框闪现的情况
                  onFocus: () => {
                    form.setFieldValue('radio', ResponsibleAccountType.ASSIGN_LEADER);
                  }, // 下拉框获取焦点的时候单选选择第二个
                }}
              />
            </div>
          ) : (
            <div className={styles.radioSelect}>
              <span>指派给团队成员</span>
              <V2FormSelect
                className={styles.assignAccountIds}
                placeholder='请选择指派人'
                name='assignAccountIds'
                options={refactorSelection(selection.employeeOptions)}
                config={{
                  showSearch: true,
                  onClick: e => {
                    e.preventDefault();
                    e.stopPropagation;
                  }, // 解决下拉框闪现的情况
                  onFocus: () => {
                    form.setFieldValue('radio', ResponsibleAccountType.ASSIGN_LEADER);
                  }, // 下拉框获取焦点的时候单选选择第二个
                }}
              />
            </div>
          ),
          value: ResponsibleAccountType.ASSIGN_LEADER,
        },
      ]}
    />
  </>);
};

export default Component;
